import { useEffect, useState } from 'react';
import './MessengerComposerPreviews.css';
import { AttachmentCard } from '@/components/ui/AttachmentCard/AttachmentCard';

export interface MessengerComposerImagePreviewsProps {
  files: FileList | readonly File[] | undefined;
  onRemove: (index: number) => void;
}

function filesToArray(files: FileList | readonly File[] | undefined): File[] {
  if (!files?.length) return [];
  return Array.from(files as ArrayLike<File>);
}

function formatKb(bytes: number): string {
  return `${Math.max(1, Math.round(bytes / 1024))} КБ`;
}

/** Превью выбранных вложений над полем ввода — фото и файлы (например Excel) для агента. */
export function MessengerComposerImagePreviews({ files, onRemove }: MessengerComposerImagePreviewsProps) {
  const arr = filesToArray(files);
  const [previewUrls, setPreviewUrls] = useState<(string | null)[]>([]);

  useEffect(() => {
    if (arr.length === 0) {
      setPreviewUrls([]);
      return;
    }
    const urls = arr.map((f) => (f.type.startsWith('image/') ? URL.createObjectURL(f) : null));
    setPreviewUrls(urls);
    return () => urls.forEach((u) => u && URL.revokeObjectURL(u));
  }, [files]);

  if (arr.length === 0) return null;

  return (
    <div className="chatAssistant__filePreviews">
      {arr.map((file, i) => {
        const url = previewUrls[i];
        if (url) {
          return (
            <AttachmentCard
              key={`${i}-${url}`}
              variant="image"
              title="Изображение"
              src={url}
              onRemove={() => onRemove(i)}
              removeButtonClassName="chatAssistant__close"
            />
          );
        }
        return (
          <AttachmentCard
            key={`${i}-${file.name}-${file.size}`}
            variant="file"
            title={file.name || 'Файл'}
            subtitle={formatKb(file.size)}
            onRemove={() => onRemove(i)}
            removeButtonClassName="chatAssistant__close"
          />
        );
      })}
    </div>
  );
}
